export const ShortInfo = [
  {
    color: "#333D29",
    photo: "Images/nr1.jpg",
    title: "Pielęgnacja drzew i zabezpieczanie koron",
    short:
      "Wszystkie drzewa rosnące na terenach zurbanizowanych potrzebują zabiegów pielęgnacyjnych...",
    content:
      "Wszystkie drzewa rosnące na terenach zurbanizowanych potrzebują zabiegów pielęgnacyjnych we wszystkich etapach rozwoju. Młode drzewa trzeba kształtować tak, aby nie kolidowały w późniejszym okresie z infrastrukturą i rozwijały się prawidłowo. Drzewa dojrzałe i sędziwe również mogą wymagać korekcji lub zabezpieczenia korony. Celem pielęgnacji drzew jest zapewnienie im jak najdłuższego życia w harmonii ze środowiskiem, w którym rosną.",
  },
  {
    color: "#656D4A",
    photo: "Images/nr2.jpg",
    title: "Wycinka drzew w trudno dostępnych miejscach",
    short:
      "Wszystkie drzewa rosnące na terenach zurbanizowanych potrzebują zabiegów pielęgnacyjnych...",
    content:
      "Wycinamy drzew z wykorzystaniem technik alpinistycznych. Umożliwia to działanie nawet w najbardziej zurbanizowanym ternie i gwarantuje 100% bezpieczeństwa dla twojego mienia.",
  },
  {
    color: "#414833",
    photo: "Images/nr3.jpg",
    title: "Interwencje po zdarzeniach pogodowych",
    short:
      "Wszystkie drzewa rosnące na terenach zurbanizowanych potrzebują zabiegów pielęgnacyjnych...",
    content:
      "Pomożemy ci, gdy twoje drzewa ucierpią po nagłych zdarzeniach pogodowych.",
  },
];
